import { Reveal, Overline } from "./Reveal";
import { PROCESS } from "@/data/content";

export default function Process() {
  return (
    <section className="border-y border-royal-line bg-white py-28 md:py-40" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <Reveal>
                <Overline>Como trabalhamos</Overline>
                <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-royal-deep md:text-6xl">
                  Da ideia <br />
                  ao <em className="text-royal">impacto.</em>
                </h2>
                <p className="mt-8 max-w-sm text-base leading-relaxed text-muted-foreground">
                  Um processo simples e transparente: quatro etapas, sempre com as duas mentes da
                  Creative envolvidas.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            {PROCESS.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.08}>
                <div
                  className="group grid grid-cols-[auto_1fr] items-baseline gap-6 border-t border-royal/15 py-10 transition-colors duration-500 last:border-b hover:bg-royal/5 md:gap-12 md:py-12"
                  data-testid={`process-step-${step.n}`}
                >
                  <span className="font-display text-5xl font-medium italic text-royal/30 transition-colors duration-500 group-hover:text-royal md:text-7xl">
                    {step.n}
                  </span>
                  <div>
                    <h3 className="font-display text-3xl font-medium text-royal-deep md:text-4xl">
                      {step.title}
                    </h3>
                    <p className="mt-3 max-w-md text-base leading-relaxed text-muted-foreground">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
